export type TranslateData = Record<string, string | number>

/**
 * Spłaszcza zagnieżdżony plik `*.resources.json` do mapy `'a.b.c' -> tekst`.
 *
 * Klucze w kodzie zawsze są kropkowane, a pliki mają do pięciu poziomów - trzymanie
 * płaskiej mapy oszczędza schodzenie po ścieżce przy każdym wywołaniu `t`.
 */
export const flattenTranslations = (
  source: Record<string, any>,
  prefix = '',
  target: Record<string, string> = {},
) => {
  for (const key of Object.keys(source)) {
    const value = source[key]
    const path = prefix ? `${prefix}.${key}` : key
    if (value != null && typeof value === 'object') {
      flattenTranslations(value, path, target)
    } else if (value != null) {
      target[path] = String(value)
    }
  }
  return target
}

/** `${ nazwa }` w tekście tłumaczenia - taki sam zapis, jaki miała biblioteka. */
const PLACEHOLDER = /\$\{\s*([\w.]+)\s*\}/g

/**
 * Podstawia dane pod `${...}`. Brakujący klucz zostaje w tekście jako placeholder -
 * lepiej zobaczyć `${date}` w UI niż ciche `undefined` w środku zdania.
 */
export const fillPlaceholders = (text: string, data?: TranslateData | null) => {
  if (!data) {
    return text
  }
  return text.replace(PLACEHOLDER, (match, key: string) => {
    const value = data[key]
    return value == null ? match : String(value)
  })
}

/** Komunikat zastępczy dla nieznanego klucza - format przejęty z react-localize-redux. */
export const missingTranslation = (key: string, languageCode: string) =>
  `Missing translationId: ${key} for language: ${languageCode}`
